import { toAbsoluteUrl } from '../../../helpers';

export function FallbackView() {
  return (
    <div className="splash-screen">
      <img src={toAbsoluteUrl('/media/logos/logo-4_eski.svg')} alt="Logo" />
      <span>Yükleniyor ...</span>
    </div>
  );
}
